import React from 'react';
import { ErrorMessage, Field } from 'formik';
import Anchor from '../form-elements/Anchor';
import { InternalLink } from '../form-elements/Link';

function AccountInformation() {
    return (
        <li className="uk-open uk-margin-remove">
            <Anchor className="uk-accordion-title" style={{ fontSize: 'inherit' }}>
                <div className="uk-flex uk-flex-middle">
                    <span className="uk-badge aps-background-primary-light uk-margin-small-right">2</span>
                    <div className="step-title uk-text-bold uk-text-large">Kundenkonto Informationen</div>
                </div>
            </Anchor>
            <div className="uk-accordion-content uk-margin-remove">
                <div style={{ marginLeft: 10, paddingLeft: 10, borderLeft: '1px solid grey' }}>
                    <div className="uk-padding-small">
                        <div className="uk-text-bold">Alle mit * gekennzeichneten Felder sind Pflichtfelder</div>
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="email">E-Mail-Adresse *</label>
                            <Field id="email" name="email" className="uk-input" type="email" placeholder="E-Mail-Adresse" />
                            <ErrorMessage component="div" className="uk-text-danger" name="email" />
                        </div>
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="password">Passwort *</label>
                            <Field id="password" name="password" className="uk-input" type="password" placeholder="Passwort" />
                            <ErrorMessage component="div" className="uk-text-danger" name="password" />
                        </div>
                        <div className="uk-margin">
                            <label className="uk-form-label" htmlFor="confirmPassword">Passwort wiederholen *</label>
                            <Field id="confirmPassword" name="confirmPassword" className="uk-input" type="password" placeholder="Passwort wiederholen" />
                            <ErrorMessage component="div" className="uk-text-danger" name="confirmPassword" />
                        </div>
                        <div className="uk-margin">
                            <label htmlFor="terms">
                                <Field id="terms" className="uk-checkbox" type="checkbox" name="terms" aria-required="true" />
                                <span> Ich akzeptiere </span>
                                <InternalLink newTab to="/agb">
                                    <u>die Allgemeinen Geschäftsbedingungen.</u>
                                </InternalLink>
                                <span> *</span>
                            </label>
                            <ErrorMessage component="div" className="uk-text-danger" name="terms" />
                        </div>
                        <div className="uk-margin">
                            <label htmlFor="privacy">
                                <Field id="privacy" className="uk-checkbox" type="checkbox" name="privacy" aria-required="true" />
                                <span> Ich habe die </span>
                                <InternalLink newTab to="/datenschutz">
                                    <u>Datenschutzhinweise</u>
                                </InternalLink>
                                <span> zur Kenntnis genommen. *</span>
                            </label>
                            <ErrorMessage component="div" className="uk-text-danger" name="privacy" />
                        </div>
                    </div>
                </div>
            </div>
        </li>
    );
}

export default AccountInformation;
